module.exports = __webpack_public_path__ + "static/img/homeNsyx.5ee251c8.png";